import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../repositories/auth.service';
import {AccountType} from '../models/account-type';

@Injectable({
  providedIn: 'root'
})
export class CanEditGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private authService: AuthService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const user = this.authService.getUserStatus();
    const canEdit = !(user.applicationStatus === 'Validation' ||
      user.applicationStatus === 'AccountPending' ||
      user.applicationStatus === 'Success' ||
      (user.applicationStatus === 'Clone' && !user.isAdmin));

    if (!canEdit) {
      if (state.url.includes('documents') || state.url.includes('thank')) {
        return true;
      }

      if ((user.hasProofAddressDocument && user.hasProofIdentetyDocument) || user.documentsNotRequired) {
        this.router.navigate(['thankyoufinish']);
      } else {
        const path = user.accountType === AccountType.Single ? 'documents' : 'documents-first-holder';
        this.router.navigate(['/workspace', {outlets: {stages: [path]}}]);
      }
    }

    return canEdit;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const user = this.authService.getUserStatus();
    const canEdit = !(user.applicationStatus === 'Validation' ||
      user.applicationStatus === 'AccountPending' ||
      user.applicationStatus === 'Success' ||
      (user.applicationStatus === 'Clone' && !user.isAdmin));

    if (!canEdit) {
      if ((user.hasProofAddressDocument && user.hasProofIdentetyDocument) || user.documentsNotRequired) {
        this.router.navigate(['thankyoufinish']);
      } else {
        const path = user.accountType === AccountType.Single ? 'documents' : 'documents-first-holder';
        this.router.navigate(['/workspace', {outlets: {stages: [path]}}]);
      }
    }

    return canEdit;
  }
}
